import React from 'react'

import { useTranslation } from '@disco/i18n/use-translation'

import { Text } from 'components/ds'

import styles from './index.module.css'

export const SearchResultsSource: React.FC = () => {
  const { t } = useTranslation('search')
  return (
    <Text size="2" className={styles.sourceText}>
      {t('search:resultsProvidedByAims', 'Results provided by AIMS')}
    </Text>
  )
}
